import menu from './zhCN/menu';
import daily from './zhCN/daily';
import active from './zhCN/active';
import churn from './zhCN/churn';
import common from './zhCN/common';
import header from './zhCN/header';
import ltv from './zhCN/ltv';
import monthly from './zhCN/monthly';
import realtime_revenue from './zhCN/realtime_revenue';
import realtime_users from './zhCN/realtime_users';
import register from './zhCN/register';
import retention from './zhCN/retention';
import returns from './zhCN/return';
import revenue from './zhCN/revenue';
import ua_no_spend from './zhCN/ua_no_spend';
import ua from './zhCN/ua';
import weekliy from './zhCN/weekliy';
import filter from './zhCN/filter';
import overview from './zhCN/overview';
import trackingDayComponent from './zhCN/trackingDayComponent';
import gameSelector from './zhCN/gameSelector';
import selectorMultipleComponent from './zhCN/selectorMultipleComponent';
import regionSelectorComponent from './zhCN/regionSelectorComponent';
import dateComparison from './zhCN/date_comparison';
import EventComparison from './zhCN/event_comparison';
import countryComparison from './zhCN/country_comparison';
import commonOptions from './zhCN/common_options';
import metricsSelect from './zhCN/metricsSelect';
import showMoreStatistics from './zhCN/showMoreStatistics';
import refreshComponent from './zhCN/refreshComponent';
import downloadFormatModalComponent from './zhCN/downloadFormatModalComponent';
import dailyByTimezone from './zhCN/dailyByTimezone';
import newUsersRetentionByTimezone from './zhCN/newUsersRetentionByTimezone';
import metricsSetting from './zhCN/metricsSetting';
import competitor from './zhCN/competitor';
import eventAnalysis from './zhCN/eventAnalysis';
import subscribe from './zhCN/subscribe';
import errorCode from './zhCN/errorCode';
import userGuid from './zhCN/user_guide';
import funnel from './zhCN/funnel';
import pcConsoleRevenue from './zhCN/pcConsoleRevenue';
import poeFilter from './zhCN/poeFilter';
import wow from './zhCN/wow';
import benchmark from './zhCN/benchmark';
import sth from './zhCN/sth';
import secureIframeRender from './zhCN/secureIframeRender';

export default {
  ...daily,
  ...active,
  ...churn,
  ...common,
  ...header,
  ...ltv,
  ...monthly,
  ...realtime_revenue,
  ...realtime_users,
  ...register,
  ...retention,
  ...returns,
  ...revenue,
  ...ua_no_spend,
  ...ua,
  ...weekliy,
  ...filter,
  ...overview,
  ...trackingDayComponent,
  ...gameSelector,
  ...selectorMultipleComponent,
  ...regionSelectorComponent,
  ...menu,
  ...dateComparison,
  ...EventComparison,
  ...commonOptions,
  ...metricsSelect,
  ...showMoreStatistics,
  ...countryComparison,
  ...refreshComponent,
  ...downloadFormatModalComponent,
  ...dailyByTimezone,
  ...newUsersRetentionByTimezone,
  ...metricsSetting,
  ...competitor,
  ...eventAnalysis,
  ...errorCode,
  ...subscribe,
  ...userGuid,
  ...funnel,
  ...pcConsoleRevenue,
  ...poeFilter,
  ...wow,
  ...benchmark,
  ...sth,
  ...secureIframeRender,
};
